import { css, keyframes } from "@sourceful/shared-components";

export const fadeIn = keyframes({
  "0%": {
    opacity: 0,
  },
  "100%": {
    opacity: 1,
  },
});

export const accordionStyles = css({
  ".accordion": {
    border: "1px solid rgba(0, 0, 0, 0.1)",
    borderRadius: "2px",
  },

  ".accordion__item + .accordion__item": {},

  ".accordion__item:after": {
    backgroundColor: "#DCDCDD",
    content: "",
    display: "block",
    height: "1px",
    width: "100%",
  },
  ".accordion__heading": {
    width: "100%",
  },
  ".accordion__button": {
    backgroundColor: "white",
    color: "#444",
    cursor: "pointer",
    padding: "18.5px",
    width: "100%",
    textAlign: "left",
    border: "none",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "$p1",
    fontWeight: "$latin_1_variable_semibold",
    "&:hover": {
      color: "$palette1_colour1",
    },
  },
  ".accordion__button:after": {
    color: "$palette1_colour1",
    display: "inline-block",
    content: "",
    height: "10px",
    width: "10px",
    // marginRight: "12px",
    borderBottom: "2px solid currentColor",
    borderRight: "2px solid currentColor",
    transform: "rotate(45deg)",
    marginBottom: "5px",
    transition: "all 0.2s",
  },

  ".accordion__button[aria-expanded='true']::after, .accordion__button[aria-selected='true']::after": {
    transform: "rotate(225deg)",
    position: "relative",
    marginTop: "10px",
  },
  "[hidden]": {
    display: "none",
  },
  ".accordion__panel": {
    color: "#747477",
    padding: "20px",
    paddingTop: "0px",
    animation: `${fadeIn} 0.35s ease-in`,
  },
});
